module.exports = __webpack_public_path__ + "assets/argent.916a7292.svg";